import { schema } from "normalizr";
import { stopSubmit } from "redux-form";
import { createAsyncAction, request } from "../lib/utils";

const agency = new schema.Entity("agencies", {}, { idAttribute: "uid" });

export const getAction = createAsyncAction("get");
export const get = (uid, view = "default") => async (dispatch, getState) => {
  return request("get", `/v1/agencies/${uid}`, null, {
    view,
    action: getAction,
    schema: agency,
    dispatch
  });
};

export const updateAgencyAction = createAsyncAction("updateAgency");
export const updateAgency = (data, uid) => async (dispatch, getState) => {
  return request(
    "patch",
    `/v1/agencies/${uid}`,
    {
      data
    },
    { action: updateAgencyAction, dispatch }
  );
};

export const uploadLogoAction = createAsyncAction("uploadLogo");
export const uploadLogo = files => async (dispatch, getState) => {
  let formData = new FormData();
  formData.append("file", files[0]);

  return request(
    "post",
    `/v1/files?type=image`,
    {
      data: formData
    },
    {
      errorHandler: ({ response }) => {
        if (response.status !== 200) {
          dispatch(
            stopSubmit("settingsForm", {
              logoFilePreview: "Niepoprawny format lub wielkość pliku"
            })
          );
        }
      },
      action: uploadLogoAction,
      dispatch
    }
  );
};



// WEBPACK FOOTER //
// ./src/settings/actions.js